/**
 * Unblock Dialog Component
 * 
 * Confirmation dialog for unblocking a user.
 */

import * as React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Loader2 } from "lucide-react";
import type { Block } from "@/services/blockService";

interface UnblockDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  block: Block | null;
  onConfirm: () => void;
  loading: boolean;
}

export function UnblockDialog({
  open,
  onOpenChange,
  block,
  onConfirm,
  loading,
}: UnblockDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Konfirmasi Unblock</AlertDialogTitle>
          <AlertDialogDescription>
            Apakah Anda yakin ingin meng-unblock user ini?
            <br />
            <br />
            <strong>Callsign:</strong> {block?.callsign || "-"}
            <br />
            <strong>ID Client:</strong> {block?.id_client || "-"}
            <br />
            <strong>Nama:</strong> {block?.nama || "-"}
            {block?.reason && (
              <>
                <br />
                <strong>Alasan:</strong> {block.reason}
              </>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={loading}>Batal</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={loading}
            className="bg-red-600 hover:bg-red-700"
          >
            {loading ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Memproses...
              </>
            ) : (
              "Unblock"
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

